import { Box } from '@mui/system'
import classnamesBind from 'classnames/bind'
import RobbitLogo from '@/assets/icons/robbit-logo.png'
import { LoadingImage } from '@/components/Icons/icon-files'

import styles from './loading.scss'

const cn = classnamesBind.bind(styles)

export const Loading = () => (
  <Box className={cn('loader')}>
    <Box className={cn('loader__img-wrapper')}>
      <Box component="img" className={cn('loader__img')} src={RobbitLogo} alt="logo" width={154} height={40} />
    </Box>
  </Box>
)
